export const cssStyles = `
.hire-body {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 55px;
  font-family: Arial, sans-serif;
  color: #000;
  font-size: 16px;
  line-height: 1.4;
}

.hire-body p {
  margin: 0 0 10px 0;
  padding: 0;
}

.hire-header {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  margin-bottom: 16px;
}

.hire-title {
  font-weight: bold;
  font-size: 24px;
}

.hire-paragraph {
  font-size: 15px;
  line-height: 1.5;
  margin-bottom: 10px;
}

.hire-paragraph-small {
  font-size: 13px;
  margin-bottom: 10px;
}

.hire-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
  margin-bottom: 15px;
}

.hire-label-cell {
  border: 1px solid black;
  padding: 8px 12px;
  vertical-align: top;
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
}

.hire-value-cell {
  border: 1px solid black;
  padding: 8px 12px;
  vertical-align: top;
  font-size: 15px;
  width: 100%;
}

.hire-product-row {
  padding: 3px 0;
}

.hire-direct-debit {
  margin-top: 20px;
  margin-bottom: 30px;
}

.hire-direct-debit-title {
  font-weight: bold;
  color: #000;
  font-size: 20px;
  margin-bottom: 10px;
}

.hire-direct-debit-recommended {
  color: #2e7d32;
}

.hire-direct-debit-link {
  color: #1a0dab;
  text-decoration: underline;
}
`;
